import { create } from "zustand";
import { placeOrderApi, getOrderFunction, getOrderByIdFunction } from "../api/order";


export const useOrderStore = create((set, get) => ({
    loading: false,
    order: [],
    placeOrder: async (items, shippingAddress, isCartInvolved) => {
        try {
            set({ loading: true })
            const res = await placeOrderApi(items, shippingAddress, isCartInvolved)
            set({ loading: false });
            return res
        } catch (error) {
            console.error("Login failed:", error);
            set({ loading: false });
            throw error;
        }
    },
    getOrder: async (pageNumber, pageSize, search, field, dateRange) => {
        set({ loading: true })
        try {
            const res = await getOrderFunction(pageNumber, pageSize, search, field, dateRange)
            // console.log("getAllOrder", res)
            set({ loading: false, order: res?.ref })
            return res
        } catch (error) {
            console.error("Login failed:", error);
            set({ loading: false });
            throw error;
        }
    },
    getOrderById: async (id) => {
        set({ loading: true })
        try {
            const res = await getOrderByIdFunction(id)
            set({ loading: false })
            return res
        } catch (error) {
            console.error("Login failed:", error);
            set({ loading: false });
            throw error;
        }
    },
}))